import Vue from 'vue'
import store from 'store'
import select from 'dom-select'
import on from 'dom-event'
import Flickity from 'flickity'

import {
  set,
  unset,
  contains
} from 'utils/general'
import { mapState, mapActions } from 'vuex'

const HIDDEN_PRODUCT_TAG = 'HIDDEN'
const hasHiddenProductTag = product => Array.isArray(product.tags) && product.tags.includes(HIDDEN_PRODUCT_TAG)

export default el => Promise.all([
  enqueueModule('vue-image.vue')
]).then(() => {
  return new Vue({
    el,
    store,
    data () {
      return {
        searchText: '',
        products: [],
        collections: [],
        contents: [],
        flkty: [],
        searchSectionVisible: false
      }
    },
    computed: {
      ...mapState({
        searchOpened: state => state.global.searchOpened
      })
    },
    watch: {
      searchText: {
        handler () {
          if (this.searchText.length >= 3) {
            this.searchSectionVisible = false
            this.searchItems(this.searchText)
              .then(res => {
                const { articles, collections, pages, products } = res.resources.results
                this.products = products.filter(product => !hasHiddenProductTag(product))
                this.collections = collections
                this.contents = [...articles, ...pages]

                if (this.products.length > 0) {
                  this.searchSectionVisible = true
                  this.initializeCarousel()
                }
              }).catch(err => {
                console.log(err)
              })
          }
        }
      },
      searchOpened: {
        handler () {
          const body = select('body')
          const header = select('#header')
          const searchContainer = select('.section-header--search')

          if (this.searchOpened) {
            set(body, 'overflow--hidden')
            set(header, 'search--opened')
            set(searchContainer, 'search--opened')
          } else {
            unset(body, 'overflow--hidden')
            unset(header, 'search--opened')
            unset(searchContainer, 'search--opened')
          }
        }
      }
    },
    created () {
      const body = select('body')
      on(body, 'click', e => {
        if (!e.target.closest('.header-search') && !contains(e.target, 'js-search-open') && this.searchOpened && !contains(e.target, 'search-mobile-icon')) {
          this.toggleSearch()
        }
      })
    },
    beforeDestroy () {
      // Destroy Flickity instance on component destroy
      if (this.flkty.lenght > 0) {
        this.flkty.destroy()
        this.flkty = []
      }
    },
    methods: {
      ...mapActions('global', [
        'searchItems',
        'toggleSearch'
      ]),
      initializeCarousel () {
        this.$nextTick(() => {
          if (this.flkty.lenght > 0) {
            this.flkty.destroy() // Destroy the existing Flickity instance if it exists
            this.flkty = []
          }

          this.flkty = new Flickity(this.$refs.carouselproductsearch, {
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'left',
            freeScroll: true,
            wrapAround: false,
            groupCells: 1,
            contain: true,
            imagesLoaded: true
          })

          this.flkty.resize()
        })
      },
      computedVendor (title) {
        if (title.includes('-')) {
          return title.split('-')[0]
        } else {
          return false
        }
      },
      computedTitle (title) {
        return title.split('-').slice(-1).pop()
      },
      closeSearch () {
        this.searchText = ''
        this.toggleSearch()
      },
      submitForm () {
        window.location.href = `/search?q=${this.searchText}`
      }
    }
  })
})
